import React, {useState} from 'react';
import {Button} from '@components';
import {Card, Form, Row, Col, ButtonGroup} from 'react-bootstrap';
import {Formik} from 'formik';
import * as yup from 'yup';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {
    acceptImage,
    DATE_TIME_REACT_FORMAT,
    DATE_TIME_REACT_WITHOUT_HOUR_FORMAT,
    messageError,
    messageToast,
    objectLoai,
    objectLoaiNoiDung,
    objectTrangThaiDeNghi,
    status200,
    styleSelectDefault,
    styleSelectError
} from '../../utils/define';
import {addEmailConfigAction} from '../../store/reducers/emailConfig';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';
import {BaseGatewayAuthImage, SIGNEDHUMAN_API, ROLE_API} from '@app/utils/apiUrl';
import {useMutation, useQuery} from 'react-query';
import Editor from '@app/components/editor/Editor';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import {AsyncPaginate} from 'react-select-async-paginate';
import {Get, Post} from '@app/utils/httpProvider';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import InputFile from '@app/components/input-file/InputFile';

const schema = yup.object().shape({
    fullName: yup.string().required(messageError.emptyMessage),
});

const SignedHumanAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) =>
        Post(SIGNEDHUMAN_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = values;

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(true);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm thông tin người được ký</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        fullName: '',
                        address: '',
                        phoneNumber: '',
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        errors,
                        setFieldValue
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Họ tên',
                                        name: 'fullName',
                                        value: values.fullName,
                                        onChange: handleChange,
                                        isInvalid: errors.fullName,
                                        error: errors.fullName
                                    },
                                    {
                                        label: 'Địa chỉ',
                                        name: 'address',
                                        value: values.address,
                                        onChange: handleChange,
                                        isInvalid: errors.address,
                                        error: errors.address
                                    },
                                    {
                                        label: 'Số điện thoại',
                                        name: 'phoneNumber',
                                        value: values.phoneNumber,
                                        onChange: handleChange,
                                        isInvalid: errors.phoneNumber,
                                        error: errors.phoneNumber
                                    }
                                ]}
                            />
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{span: 10, offset: 2}}>
                                    <ButtonGroup className="mb-2">
                                        <Button
                                            type="submit"
                                            theme="primary"
                                            disabled={isLoading}
                                        >
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button
                                            onClick={() => history.goBack()}
                                            theme="secondary"
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default SignedHumanAdd;
